import styled from "styled-components";

export const ChoosePlansNavBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  height: 100px;
  margin: 0 5%;
`

export const ChoosePlansNavBarUserInfo = styled.div`
  display: flex;
  flex-direction: row;
  height: 100px;
  align-items: center;
  column-gap: 15px;
`

export const ChoosePlansNavBarUserImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FE2F67;
  border-radius: 50%;
  width: 45px;
  height: 45px;
`
